import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import InfoSections from "./components/InfoSections";
import Faq from "./components/Faq";
import ArticleEntry from "./components/ArticleEntry";
import { MAIN_SITE_URL } from "@/mocks/site";

function FinalCta() {
  const { t } = useTranslation();
  return (
    <section className="bg-primary-500">
      <div className="mx-auto max-w-3xl px-4 py-16 text-center md:px-6 md:py-20">
        <h2 className="text-2xl font-bold text-white md:text-4xl">{t("final.title")}</h2>
        <p className="mx-auto mt-4 max-w-xl text-sm text-white/90 md:text-base">
          {t("final.subtitle")}
        </p>
        <a
          href={MAIN_SITE_URL}
          target="_blank"
          rel="noopener nofollow"
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-white px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 cursor-pointer"
        >
          {t("final.button")}
          <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (target) {
      const timer = setTimeout(() => {
        document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <InfoSections />
        <ArticleEntry />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}